// extracted by mini-css-extract-plugin
export var fadeIn = "_mg-1";
export var modalContent = "_mg-3";
export var overlay = "_mg-0";
export var popoverContent = "_mg-2";
export var results = "_mg-5";
export var searchInputWrapper = "_mg-4";